import { fetchHil } from "../utils";
import * as _ from "lodash";

export default {
  namespaced: true,
  state: {
    hosts: {},
    currentHostProjects: [],
    currentHostProjectsLoaded: false
  },
  mutations: {
    setHosts(state, { hosts, count, page }) {
      state.hosts = {
        items: hosts,
        count,
        page
      };
    },

    setCurrentProject(state, project) {
      state.currentProject = _.cloneDeep(project);
      state.currentProjectProposals = [];
      state.currentProjectProposalsLoaded = false;
      state.currentProjectComments = [];
      state.currentProjectCommentsLoaded = false;
    },

    setLeasesForHost(state, leases) {
      state.currentHostProjects = leases;
      state.currentHostProjectsLoaded = true;
    }
  },
  actions: {
    async fetchHosts({ commit }, { page, search, filters }) {
      const PAGE_SIZE = 60;
      const fAvailable = filters.indexOf("available") !== -1;
      const fNotAvailable = filters.indexOf("not-available") !== -1;
      const fNo =
        (fAvailable && fNotAvailable) || (!fAvailable && !fNotAvailable);
      const params = {
        offset: page * PAGE_SIZE,
        size: PAGE_SIZE,
        input: search,
        isActive: fNo ? undefined : !fNotAvailable
      };
      const resp = await fetchHil(`/hosts/_search`, {
        method: "POST",
        body: params
      });

      const hosts = await resp.json();
      commit("setHosts", {
        hosts,
        count: +resp.headers.get("x-total-count"),
        page
      });
    },

    async fetchLeasesForHost({ commit }, { id }) {
      const resp = await (await fetchHil(`/proposals/host/${id}`)).json();
      commit("setLeasesForHost", resp);
    }
  }
};
